import type { Site } from './types';

export async function syncRegistry(token: string, sites: Site[]) {
  if (!token) return;
  try {
    await fetch('/api/registry', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token,
        sites: sites.map((s) => ({
          id: s.id,
          name: s.name,
          domain: s.domain,
          trackingCode: s.trackingCode,
          status: s.status,
          industry: s.industry || '',
          lastCollectAt: s.lastCollectAt,
          createdAt: s.createdAt,
        })),
      }),
    });
  } catch {
    /* 预览/静态部署时允许失败 */
  }
}
